import React from 'react';

export const LangChangeEventContext = React.createContext({
    lang: "ru",
    changeRu: () => {},
    changeEn: () => {}
});



// WEBPACK FOOTER //
// ./src/contexts/LangContext.js